
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Animation utility functions
export const animations = {
  // Generate a random delay for staggered animations
  randomDelay: (max = 0.5) => {
    return Math.random() * max;
  },
  
  // Generate a random duration for varied animation speeds
  randomDuration: (min = 1, max = 3) => {
    return min + Math.random() * (max - min);
  },
  
  // Get a random color from our theme colors
  randomColor: () => {
    const colors = ['#9b87f5', '#2DD4BF', '#0EA5E9', '#8B5CF6', '#A78BFA'];
    return colors[Math.floor(Math.random() * colors.length)];
  },
  
  // Generate a unique animation seed for components
  getAnimationSeed: () => {
    return Math.random();
  },
  
  // Variants for staggered children animations (for framer-motion)
  staggerContainer: (staggerChildren = 0.05, delayChildren = 0) => ({
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren,
        delayChildren
      }
    }
  }),
  
  // Variants for items in staggered containers
  staggerItem: (y = 20) => ({
    hidden: { y, opacity: 0 },
    show: { y: 0, opacity: 1 }
  }),
  
  // Keyframe animations for elements
  pulse: {
    scale: [1, 1.05, 1],
    opacity: [1, 0.8, 1]
  },
  
  float: {
    y: [0, -10, 0]
  },
  
  // Create glowing orb background positions
  getOrbPositions: (count = 4) => {
    const orbs = [];
    for (let i = 0; i < count; i++) {
      orbs.push({
        size: 150 + Math.random() * 100,
        x: Math.random() * 100,
        y: Math.random() * 100,
        color: i % 2 === 0 ? '#9b87f5' : '#2dd4bf',
        delay: i * 1.5,
        duration: 8 + i
      });
    }
    return orbs;
  }
}

// Detect if user prefers reduced motion
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// Create dynamically animated neural network path data
export function createNeuralPathData(index: number, seed: number): string {
  const yPos = 10 + (index * 80 / 5); // Distribute across screen
  const pathVariation = Math.sin(index * 1.5) * 10;
  
  return `M0,${yPos} Q${25 + seed * 10},${yPos + pathVariation} ${50 - seed * 15},${yPos - 5} T100,${yPos + seed * 8}`;
}
